import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger } from '../ui/select';
import {
  Trash2, ToggleLeft, ToggleRight, Sparkles, Square, CheckSquare,
} from 'lucide-react';

export const BulkActionsBar = ({
  selectedCount,
  totalFiltered,
  bulkDeleteArmed,
  autoCategorizing,
  filterType,
  categories,
  incomeCategories,
  onSelectAll,
  onBulkFinalize,
  onBulkDraft,
  onBulkDelete,
  onBulkSetCategory,
  onAutoCategorize,
}) => {
  const { t } = useTranslation();
  const allSelected = selectedCount > 0 && selectedCount === totalFiltered;

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        size="sm"
        onClick={onSelectAll}
        data-testid="select-all-btn"
      >
        {allSelected ? <CheckSquare className="mr-2 h-4 w-4" /> : <Square className="mr-2 h-4 w-4" />}
        {allSelected && totalFiltered > 0
          ? t('transactions.deselect_all', 'Deselect All')
          : t('transactions.select_all', 'Select All')}
      </Button>

      {selectedCount > 0 && (
        <>
          <Badge variant="secondary" className="px-3 py-1">
            {selectedCount} {t('common.selected', 'selected')}
          </Badge>

          <Button onClick={onBulkFinalize} size="sm" className="bg-emerald-600 hover:bg-emerald-700" data-testid="bulk-final-btn">
            <ToggleRight className="w-4 h-4 mr-2" />Mark Final
          </Button>

          <Button onClick={onBulkDraft} variant="outline" size="sm" className="border-orange-300 text-orange-600 hover:bg-orange-50" data-testid="bulk-draft-btn">
            <ToggleLeft className="w-4 h-4 mr-2" />Mark Draft
          </Button>

          <Button
            onClick={onBulkDelete}
            variant="destructive"
            size="sm"
            className={bulkDeleteArmed ? 'bg-red-700 animate-pulse' : ''}
            data-testid="bulk-delete-btn"
          >
            <Trash2 className="w-4 h-4 mr-2" />
            {bulkDeleteArmed ? 'Confirm Delete' : 'Delete'}
          </Button>

          <Select onValueChange={onBulkSetCategory} value="" data-testid="bulk-set-category-select">
            <SelectTrigger className="h-8 w-40 text-xs border-stone-300" data-testid="bulk-category-trigger">
              <span className="text-stone-500">Set Category…</span>
            </SelectTrigger>
            <SelectContent>
              {(filterType === 'income' ? incomeCategories : categories).map(cat => (
                <SelectItem key={cat.id} value={cat.id} className="text-xs">{cat.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>

          <Button
            onClick={onAutoCategorize}
            disabled={autoCategorizing}
            size="sm"
            className="bg-violet-600 hover:bg-violet-700 text-white"
            data-testid="auto-categorize-btn"
          >
            {autoCategorizing
              ? <><Sparkles className="w-4 h-4 mr-2 animate-spin" />Categorizing...</>
              : <><Sparkles className="w-4 h-4 mr-2" />Auto-Categorize</>}
          </Button>
        </>
      )}
    </div>
  );
};
